<template>
        <b-dropdown
            position="is-bottom-right"
            append-to-body
            aria-role="menu"
            trap-focus
            :can-close="true"
            :close-on-click="false"
            :triggers="['click']" 
        >
        <template #trigger>
            <b-button>
                <b-icon
                    icon="filter">
                </b-icon>
                <span>
                Filter
                </span>
            </b-button>
        </template>
        <b-dropdown-item
            :focusable="false"
            custom
            paddingless>
            <div class="columns">
                <div class="column has-background-dvoalt rounded">
                    <section class="section">
                    <b-field group-multiline>
                        <b-select placeholder="Column" @input="handleFirstColumnSelect">
                                <option
                                    v-for="(option, index) in fields"
                                    :value="option"
                                    :key="index">
                                    {{ option.name }}
                                </option>
                        </b-select>
                        <b-select placeholder="Condition" v-model="firstFilter[0].condition">
                                <option
                                    v-for="(option, index) in comparitor"
                                    :value="option.value"
                                    :key="index">
                                    {{ option.name }}
                                </option>
                        </b-select>
                        <b-select placeholder="Value" v-model="firstFilter[0].value">
                            <option value="1">Option 1</option>
                            <option value="2">Option 2</option>
                        </b-select>
                    </b-field>
                    <div v-for="(selection, index) of addedFilters" :key="index" >
                        <b-field group-multiline class="my-2">
                            <b-select placeholder="AND/OR" v-model="addedFilters[index].andor">
                                <option value="AND">AND</option>
                                <option value="OR">OR</option>
                            </b-select>
                            <b-select placeholder="Column" @input="handleColumnSelect($event, index)">
                                <option
                                    v-for="(option, index) in fields"
                                    :value="option"
                                    :key="index">
                                    {{ option.name }}
                                </option>
                            </b-select>
                            <b-select placeholder="Condition" v-model="addedFilters[index].condition">
                                <option
                                    v-for="(option, index) in comparitor"
                                    :value="option.value"
                                    :key="index">
                                    {{ option.name }}
                                </option>
                            </b-select>
                            <div v-if="addedFilters[index].type === null">
                                <b-select placeholder="Value" disabled>
                                </b-select>
                            </div>
                            <div v-else>
                                <div  v-if="addedFilters[index].type === 'string'">
                                    <b-input placeholder="Value" v-model="addedFilters[index].value" class="valueInput"></b-input>
                                </div>
                                <div  v-else-if="addedFilters[index].type === 'number'">
                                    <b-numberinput v-model="addedFilters[index].value" placeholder="1" class="valueInput"></b-numberinput>
                                </div>
                                <div v-else>
                                    <b-select placeholder="Value" disabled class="valueInput">
                                    </b-select>
                                </div>

                            </div>
                            <b-icon icon="close-thick" class="mt-2 mx-2" @click="removeFilter(index)"></b-icon>
                        </b-field>
                    </div>
                    </section>
                    <section class="section">
                        <div class="columns">
                            <div class="column">
                                <b-button type='is-primary' size="is-small" @click="addFilter"><b-icon icon="plus" size="is-small" ></b-icon><span class="is-size-7"> Add New Filter </span></b-button>
                            </div>
                            <div class="column">
                                <b-button type='is-success' size="is-small" @click="emitObjArray"><b-icon icon="content-save" size="is-small" ></b-icon><span class="is-size-7"> Save Filter </span></b-button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </b-dropdown-item>
    </b-dropdown>    
</template>

<script>
export default {
    data(){
        return {
            fields: [{name: 'Warranty Id', value: 'warranty.id', type: 'string'}, {name: 'Reference #', value: 'warranty.reference_number', type: 'string'}, {name: 'Item Repaired', value:'warranty.serial_id', type: 'string'}, {name: 'Total', value: 'warranty.total', type: 'number'}, {name: 'Approval', value:'warranty.approved', type: 'string'}],
            comparitor:[{name: 'Less Than', value: '<'}, {name: 'Equal To', value: '='}, {name: 'Greater Than', value: '>'}, {name: 'Greater Than Or Equal To', value: ">="}, {name: 'Less Than Or Equal To', value: '<='}, {name: 'Like', value: 'LIKE'}],
            firstFilter: [{andor: 'AND', column: null, condition: null, value: null, type: null}],
            addedFilters: []
        }
    },
    methods:{
        addFilter(){
            this.addedFilters.push({andor: null, column: null, condition: null, value: null, type: null})
        },
        removeFilter(index){
            this.addedFilters.splice(index, 1)
        },
        handleFirstColumnSelect(event){
            this.firstFilter[0].column = event.value
            this.firstFilter[0].type = event.type
        },
        handleColumnSelect(event, index){
            this.addedFilters[index].column = event.value
            this.addedFilters[index].type = event.type
        },
        emitObjArray(){
            this.$emit('myEmit', this.firstFilter, this.addedFilters)
        }
    }
}
</script>

<style scoped>
.rounded{
    border-radius: 5px
}

.valueInput{
    min-width: 150px;
}
</style>